<template>
  <div class="quick-stats">
    <div class="stat-card">
      <div class="stat-icon views">
        <i class="fas fa-eye"></i>
      </div>
      <div class="stat-content">
        <h4>Total Views</h4>
        <div class="stat-value">{{ performanceData?.total_views?.toLocaleString() || 0 }}</div>
        <div class="stat-trend positive">
          <i class="fas fa-arrow-up"></i> 8.2%
        </div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon time">
        <i class="fas fa-clock"></i>
      </div>
      <div class="stat-content">
        <h4>Watch Time</h4>
        <div class="stat-value">{{ formatTotalWatchTime(performanceData?.total_watch_time) }}</div>
        <div class="stat-trend positive">
          <i class="fas fa-arrow-up"></i> 12.5%
        </div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon engagement">
        <i class="fas fa-chart-line"></i>
      </div>
      <div class="stat-content">
        <h4>Engagement</h4>
        <div class="stat-value">{{ performanceData?.average_engagement?.toFixed(1) || 0 }}%</div>
        <div class="stat-trend negative">
          <i class="fas fa-arrow-down"></i> 2.1%
        </div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon subscribers">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <h4>New Subscribers</h4>
        <div class="stat-value">{{ performanceData?.new_subscribers?.toLocaleString() || 0 }}</div>
        <div class="stat-trend positive">
          <i class="fas fa-arrow-up"></i> 5.8%
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickStats',
  props: {
    performanceData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatTotalWatchTime(seconds) {
      if (!seconds) return '0:00';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = Math.floor(seconds % 60);
      
      let result = '';
      if (hours > 0) result += `${hours}h `;
      if (minutes > 0) result += `${minutes}m `;
      result += `${remainingSeconds}s`;
      return result.trim();
    }
  }
}
</script>

<style scoped>
.quick-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 12px rgba(0, 0, 0, 0.1);
}

.stat-card:hover::before {
  opacity: 1;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.stat-icon.views {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
}

.stat-icon.time {
  background: linear-gradient(135deg, #10b981, #059669);
}

.stat-icon.engagement {
  background: linear-gradient(135deg, #8b5cf6, #6d28d9);
}

.stat-icon.subscribers {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.stat-content h4 {
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
}

.stat-value {
  color: #1e293b;
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0.25rem 0;
}

.stat-trend {
  font-size: 0.875rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.stat-trend.positive {
  color: #10b981;
}

.stat-trend.negative {
  color: #ef4444;
}

@media (max-width: 768px) {
  .quick-stats {
    grid-template-columns: 1fr;
  }
}
</style> 